import {
    Component,
    OnInit,
    HostBinding,
    ViewChild,
    HostListener,
    Input,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import {DataService} from 'src/app/_services/data.service';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import {trigger, state, style, transition, animate} from '@angular/animations';
import {slideRight, slideUp, anim, changeDivSize, slideDown} from 'src/app/animations';
import {NPageWithLinkComponent} from '../../n-page-with-link/n-page-with-link.component';
import {Title} from '@angular/platform-browser';
import {closeExplanationF, prevnextF, showCurrentExplanationF} from 'src/app/_core/_function/prevNext';
import {TranslateService} from '@ngx-translate/core';
import {SelseforceCommunicationService} from 'src/app/_services/selseforce-communication.service';
import {Subscription} from "rxjs";
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

@Component({
    selector: 'app-viewbuildigs-test',
    templateUrl: './viewbuildigs-test.component.html',
    styleUrls: ['./viewbuildigs-test.component.scss'],
    animations: [
        anim, slideRight, slideUp, changeDivSize, slideUp, slideDown
    ],
    host: {
        '[@anim]': ''
    }
})
export class ViewbuildigsTestComponent implements OnInit, OnDestroy {
    showComponents: boolean = false;
    title: string;
    compTile: any;
    buildingTile: any;
    projTile: any;
    compositeDesign: boolean = false;
    unika: boolean = false;
    desktopResolution: boolean = true;
    companyTitle: string = '';
    data: any;
    buildType: string = '';

    // @HostBinding('slideRight')
    @HostListener('@anim.done', ['$event']) doneDrawerHandler(event: any): void {
        this.showComponents = true;
    }

    // @HostListener('@slideRight.done', ['$event']) startDrawerHandler(event: any): void {
    //   console.log("start", event);
    // }
    bUid: string;
    building: any;
    projUid: any;
    activeDataForUser;
    statusSold: boolean = false;
    statusWating: boolean = false;
    statusFree: boolean = false;
    flatStatusClass: string;
    showPlaceHolderBuildingImage = false;
    proj: any;
    howMuchRoomsHighlight: string;
    mySubscription: any;
    removeAllMenu: boolean = false;
    p3dBuilding: boolean = true;
    showCopyNote: boolean = false;
    routeNavigate: string;
    showPhone: boolean = false;
    showPhoneNumber: boolean = false;
    phoneNumber: number;
    showCloser: boolean = false;
    removeCloseButton: boolean = false;
    areaCode: string = '+972';
    areaCodes: any[] = ['+972', '+7', '+357', '+380', '+1'];
    compTitle: string = "Spirikal";
    filter: any = {numRooms: []};
    postData: any = {};
    iframeElement: any;
    hideRoomNumberProperty: boolean = true;
    private routeUrlSubscription: Subscription;
    private routeParamsSubscription: Subscription;
    private getSpecBuildingSubscription: Subscription;
    private getSpecProjectSubscription: Subscription;

    @ViewChild(NPageWithLinkComponent) child;

    @Input() set currentRoomAmount($event) {
        this.howMuchRoomsHighlight = $event;
        if (this.filter) {
            this.filter.numRooms.push($event)
        }
    };

    @Input() set flatStatusClassValue($event) {
        this.flatStatusClass = $event;
    };

    @Output() public currentBuilding = new EventEmitter();

    constructor(
            public dataService: DataService,
            private route: ActivatedRoute,
            private router: Router,
            private titleService: Title,
            private translate: TranslateService,
            private selseF: SelseforceCommunicationService
    ) {

        this.projUid = this.route.snapshot.params.idp;
    }


    ngOnInit(): void {
        if (window.innerWidth < 1200) {
            this.desktopResolution = false;
        }
        this.routeUrlSubscription = this.route.url.subscribe(segment => {
            if (segment.length > 3) {
                for (let i = 0; segment.length > i; i++) {
                    if (segment[i].path === 'n') {
                        this.compositeDesign = true;
                    } else if (segment[i].path === 'u') {
                        this.compositeDesign = true;
                        this.unika = true;
                    }
                }
            }
        })

        this.routeParamsSubscription = this.route.params.subscribe(params => {
            if (this.route.snapshot.queryParams.m === 'all') {
                this.removeCloseButton = true;
            }
            this.building = [];
            this.bUid = params['buid'];


            this.routeNavigate = this.dataService.hoisUrl() + location.pathname + "?m=all";
            this.compTitle = this.dataService.hoisUrlGetTitle();

            let counter = 0;

            this.getSpecBuildingSubscription = this.dataService.getSpecBuilding(this.bUid).subscribe(building => {
                if (counter == 1) return;
                counter = 1;
                console.log('TEST123')
                if (building[0]) {
                    this.building = building[0];
                    localStorage.setItem('buildingName', JSON.stringify(this.building.name));
                    console.log(this.building);
                    this.buildingTile = building[0].name;
                    this.buildType = this.building.buildType;
                    if (building[0].hideRoomNumberProperty !== undefined) {
                        this.hideRoomNumberProperty = building[0].hideRoomNumberProperty;
                    } else {
                        this.hideRoomNumberProperty = true;
                    }
                    this.currentBuilding.emit(building[0]);
                    this.dataService.currentBuild(building[0]);
                    this.pageTitle();
                    setTimeout(() => {
                        if (building[0].startScene) {
                            let parts = building[0].startScene.split(',');
                            this.changeOrMoveScene(parts[0], parts[1], parts[2], parts[3], parts[4]);
                        }
                    }, 1500);
                }
            });
            this.getSpecProjectSubscription = this.dataService.getSpecProject(this.projUid).subscribe(proj => {
                this.proj = proj[0];
                this.projUid = proj[0].uid;
                this.projTile = proj[0].title;
                this.companyTitle = proj[0].companyTitle;
                if (proj[0].wholeNum !== undefined) {
                    localStorage.setItem('wholeNum', JSON.stringify(proj[0].wholeNum));
                } else {
                    localStorage.setItem('wholeNum', JSON.stringify(false));
                }
                this.pageTitle();
            });
            if (window.innerWidth < 1200) {
                this.p3dBuilding = false;
            }
            // this.dataService.saveNumRoomsFilter(3);
        });
    }

    changeOrMoveScene(scene, h, v, fov, hs) {


        const data = {
            scene: 'scene_s', // pano ID
            h: 20,
            v: 10,
            fov: 90,
            hs: ''
        };

        data.scene = scene;
        data.h = h;
        data.v = v;
        data.fov = fov;
        data.hs = hs;
        // Set url to be sure that the message will be sent to only this url
        // Full url to iframe

        postMessageToIframe(data);

        // const url = 'https://topeye.club/';


        // //  Access iframe by name
        // // const win = window.frames.tourIframe;
        // const test = document.getElementsByClassName('da-iframe');
        // if (test && test.length > 0) {
        //     const test1 = test[0].getElementsByTagName('iframe')[0];
        //     const win = test1;

        //     this.iframeElement = eval('(win.contentWindow || win.contentDocument)');

        //     this.iframeElement.postMessage(JSON.stringify(data), url);
        // }

    }


    currentRoomAmountF($event) {
        this.currentRoomAmount = $event;
        this.filter.numRooms.push($event);
    }

    flatStatusClassF($event) {
        this.flatStatusClass = $event;
    }

    pageTitle() {
        // if(this.compTile){
        if (this.projTile) {
            if (this.buildingTile) {
                // this.title = 'Spirikal' + ' - ' + this.compTile + ' - ' + this.projTile + ' - ' + this.buildingTile;
                this.title = this.compTitle + ' - ' + this.companyTitle + ' - ' + this.projTile + ' - ' + this.buildingTile;
                this.titleService.setTitle(this.title);
            }
        }
        // }
    }


    closeExplanation() {
        closeExplanationF();
    }

    showCurrentExplanation(event) {
        showCurrentExplanationF(event);
    }

    prevnextF(event, direction) {
        prevnextF(event, direction);
    };

    showCloserF(event) {
        this.showCloser = event;
    }

    goToBuilding() {
        this.child.closeEdit();
        // this.router.navigate([this.routeNavigate]);
    }

    copyInputMessage(inputElement) {
        //hint  inputElement = routeNavigate
        inputElement.select();
        document.execCommand('copy');
        inputElement.setSelectionRange(0, 0);
        this.showCopyNote = true;
        let showCopyNote = this.showCopyNote;
        setTimeout(() => {
            this.showCopyNote = false;
        }, 3000);
    }

    show3dBuilding() {
        this.p3dBuilding = true;
    }

    close3dBuilding() {
        this.p3dBuilding = false;
    }

    showStatus(status) {
        // building holder set class  class="building building-top col {{ flatStatusClass }}"
        this.flatStatusClass = status;
        switch (status) {
            case 'sold':
                this.statusFree = false;
                this.statusWating = false;
                this.statusSold = true;
                break;
            case 'waiting':
                this.statusSold = false;
                this.statusFree = false;
                this.statusWating = true;
                break;
            case 'free':
                this.statusSold = false;
                this.statusWating = false;
                this.statusFree = true;
                break;
            case 'remove':
                this.statusSold = false;
                this.statusFree = false;
                this.statusWating = false;
                this.flatStatusClass = '';
                break;
            default:
                // code block
        }

    }

    showPhoneF() {
        this.showPhone = !this.showPhone;
        if (this.showPhone) {
            this.showPhoneNumber = false;
        }
    }

    sendWatSapp() {
        let phoneNumber = this.phoneNumber + "";
        // phoneNumber = phoneNumber.substring(1);
        this.phoneNumber = +phoneNumber;
    }

    howMuchRooms(numOfRooms, event) {
        let siblings = event.target.parentNode.childNodes;
        for (let i = 0; i < siblings.length; i++) {
            if (siblings[i].classList !== undefined) {
                siblings[i].classList.remove("current");
            }
        }
        event.srcElement.classList.add("current");
        this.howMuchRoomsHighlight = numOfRooms;
    }

    projPassFromMenu(proj) {
        this.proj = proj;
        this.projUid = proj[0].uid;
    }

    ngOnDestroy() {
        this.routeUrlSubscription && this.routeUrlSubscription.unsubscribe();
        this.routeParamsSubscription && this.routeParamsSubscription.unsubscribe();
        this.getSpecBuildingSubscription && this.getSpecBuildingSubscription.unsubscribe();
        this.getSpecProjectSubscription && this.getSpecProjectSubscription.unsubscribe();
    }
}


